(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-main"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';

  function init(sid){
    const d = window.LV && window.LV[sid];
    if(!d) return;

    const variantInput = document.getElementById('lv-variant-id-' + sid);
    const priceEl      = document.getElementById('lv-price-' + sid);
    const fomoEl       = document.getElementById('lv-fomo-' + sid);
    const atcBtn       = document.getElementById('lv-atc-' + sid);
    const galleryEl    = document.getElementById('lv-gallery-' + sid);
    const stickyEl     = document.getElementById('lv-sticky-' + sid);
    const stickyBtn    = document.getElementById('lv-sticky-btn-' + sid);
    const stickyPrice  = document.getElementById('lv-sticky-price-' + sid);
    const form         = document.getElementById(d.formId);
    if(!form || !variantInput) return;

    /* ── GALLERY ── */
    const slides = galleryEl ? [...galleryEl.querySelectorAll('.lv-gallery__slide')] : [];
    const thumbs = galleryEl ? [...galleryEl.querySelectorAll('.lv-gallery__thumb')]  : [];

    function goTo(i){
      slides.forEach((s,idx)=> s.classList.toggle('is-active', idx===i));
      thumbs.forEach((t,idx)=> t.classList.toggle('is-active', idx===i));
    }
    thumbs.forEach((t,i)=> t.addEventListener('click',()=> goTo(i)));

    /* touch swipe */
    if(galleryEl){
      let sx=0;
      const stage = galleryEl.querySelector('.lv-gallery__stage');
      if(stage){
        stage.addEventListener('touchstart', e=>{ sx=e.touches[0].clientX; }, {passive:true});
        stage.addEventListener('touchend',   e=>{
          const dx = sx - e.changedTouches[0].clientX;
          if(Math.abs(dx)<50) return;
          const cur = slides.findIndex(s=>s.classList.contains('is-active'));
          goTo(dx>0 ? Math.min(cur+1,slides.length-1) : Math.max(cur-1,0));
        }, {passive:true});
      }
    }

    /* ── VARIANTS ── */
    let sel = {};
    /* seed from checked inputs */
    form.querySelectorAll('.lv-opt-btn.is-selected').forEach(b=>{
      sel[b.dataset.optIndex] = b.dataset.optValue;
    });

    function findVariant(){
      return d.variants.find(v =>
        Object.entries(sel).every(([i,val])=> v['option'+(+i+1)] === val)
      );
    }

    function money(cents){
      return (cents/100).toLocaleString('en-AU',{style:'currency',currency:'AUD'});
    }

    function updatePrice(v){
      if(!priceEl||!v) return;
      let h='';
      if(v.compare_at_price && v.compare_at_price>v.price){
        const saved = money(v.compare_at_price - v.price);
        const pct   = Math.round((v.compare_at_price-v.price)/v.compare_at_price*100);
        h += `<div class="lv-price__savings">🔥 You save ${saved} — ${pct}% off</div>`;
        h += `<div class="lv-price__row"><span class="lv-price__now">${money(v.price)}</span><s class="lv-price__was">${money(v.compare_at_price)}</s></div>`;
      } else {
        h += `<div class="lv-price__row"><span class="lv-price__now">${money(v.price)}</span></div>`;
      }
      const note = priceEl.querySelector('.lv-price__note');
      priceEl.innerHTML = h + (note ? note.outerHTML : '');
      if(stickyPrice) stickyPrice.textContent = money(v.price);
    }

    function updateFomo(v){
      if(!fomoEl) return;
      let html='';
      if(!v||!v.available){
        /* no pill when sold out — ATC says it */
      } else if(v.inventory_management==='shopify' && v.inventory_quantity!==null && v.inventory_quantity<=d.lowStock){
        html=`<span class="lv-fomo__pill lv-fomo__pill--urgent">🔥 Only ${v.inventory_quantity} left — ${d.fomoLow}</span>`;
      } else {
        html=`<span class="lv-fomo__pill lv-fomo__pill--normal">${d.fomoDefault}</span>`;
      }
      fomoEl.innerHTML=html;
    }

    function updateButton(v){
      const avail = v && v.available;
      [atcBtn, stickyBtn].forEach(btn=>{
        if(!btn) return;
        btn.disabled = !avail;
        const txt = btn.querySelector('.lv-atc__txt') || btn;
        if(!btn.querySelector('.lv-atc__txt')){
          btn.textContent = avail ? d.atcText : d.soldOut;
        } else {
          txt.textContent = avail ? d.atcText : d.soldOut;
        }
      });
    }

    function updateGallery(v){
      if(!v) return;
      const img = d.images.find(img=> img.variant_ids && img.variant_ids.includes(v.id));
      if(img){
        const idx = d.images.indexOf(img);
        if(idx>=0) goTo(idx);
      }
    }

    function onOptionClick(btn){
      const oi  = btn.dataset.optIndex;
      const val = btn.dataset.optValue;
      sel[oi] = val;

      /* update selected labels */
      const label = form.querySelector(`.lv-option__selected[data-opt="${oi}"]`);
      if(label) label.textContent = val;

      /* update button states */
      form.querySelectorAll(`.lv-opt-btn[data-opt-index="${oi}"]`).forEach(b=>{
        b.classList.toggle('is-selected', b===btn);
      });

      const v = findVariant();
      if(v){
        variantInput.value = v.id;
        updatePrice(v);
        updateFomo(v);
        updateButton(v);
        updateGallery(v);
      }
    }

    form.querySelectorAll('.lv-opt-btn').forEach(btn=>{
      btn.addEventListener('click',()=> onOptionClick(btn));
    });

    /* ── QUANTITY ── */
    const qtyInput = document.getElementById('lv-qty-' + sid);
    if(qtyInput){
      form.querySelectorAll('.lv-qty__btn').forEach(btn=>{
        btn.addEventListener('click',()=>{
          const cur = parseInt(qtyInput.value)||1;
          qtyInput.value = btn.dataset.action==='minus' ? Math.max(1,cur-1) : cur+1;
        });
      });
    }

    /* ── AJAX ATC ── */
    form.addEventListener('submit', async e=>{
      e.preventDefault();
      if(!atcBtn || atcBtn.disabled) return;
      atcBtn.classList.add('is-loading');
      atcBtn.disabled=true;

      try {
        const fd = new FormData(form);
        const res = await fetch('/cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ items:[{ id:parseInt(fd.get('id')), quantity:parseInt(fd.get('quantity')||1) }] })
        });
        if(!res.ok) throw new Error('failed');

        /* update cart bubble */
        const cart = await (await fetch('/cart.js')).json();
        document.querySelectorAll('[data-cart-count],[data-cart-item-count]').forEach(el=>{
          el.textContent=cart.item_count;
        });

        /* open drawer if theme has one, else go to cart */
        if(window.Shopify?.PaymentButton) {
          /* Try common drawer events */
          document.dispatchEvent(new CustomEvent('cart:open'));
          window.dispatchEvent(new CustomEvent('cart:updated',{detail:cart}));
        }
        /* always refresh cart count on Dawn/Debut/etc */
        if(typeof window.CartNotification !== 'undefined') {
          window.CartNotification.prototype && window.CartNotification.renderContents && window.CartNotification.renderContents({items:[{id:parseInt(fd.get('id'))}]});
        }
        /* Fallback — redirect to cart */
        setTimeout(()=>{ if(document.getElementById(d.formId)) return; window.location='/cart'; },500);

      } catch(err){
        console.error('[LashVault ATC]', err);
        if(fomoEl) fomoEl.innerHTML=`<span class="lv-fomo__pill lv-fomo__pill--urgent">Something went wrong. Please try again.</span>`;
      } finally {
        atcBtn.classList.remove('is-loading');
        atcBtn.disabled=false;
      }
    });

    /* Sticky button fires the form */
    if(stickyBtn){
      stickyBtn.addEventListener('click',()=>{
        form.dispatchEvent(new Event('submit',{bubbles:true,cancelable:true}));
      });
    }

    /* ── STICKY SHOW/HIDE ── */
    if(stickyEl && atcBtn){
      const obs = new IntersectionObserver(([e])=>{
        stickyEl.classList.toggle('is-visible', !e.isIntersecting);
        stickyEl.setAttribute('aria-hidden', e.isIntersecting);
      },{threshold:0, rootMargin:'0px 0px -20px 0px'});
      obs.observe(atcBtn);
    }
  }

  /* boot */
  function boot(){
    if(!window.LV) return;
    Object.keys(window.LV).forEach(init);
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-promo-block"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.promo-block').forEach(function (root) {
  if (root.dataset.promoInit) return;
  root.dataset.promoInit = 'true';

  var viewerEl = root.querySelector('.promo-viewer-count');
  if (viewerEl) {
    var min = parseInt(viewerEl.dataset.min, 10) || 10;
    var max = parseInt(viewerEl.dataset.max, 10) || 40;
    var numberEl = viewerEl.querySelector('.promo-viewer-number');
    setInterval(function () {
      var n = Math.floor(Math.random() * (max - min + 1)) + min;
      numberEl.textContent = n;
    }, 8000);
  }

  var form = root.querySelector('.promo-form');
  if (form) {
    var radios = form.querySelectorAll('.promo-tier-radio');
    var hiddenInput = form.querySelector('.promo-variant-input');
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        hiddenInput.value = radio.value;
        form.querySelectorAll('.promo-tier').forEach(function (label) {
          label.classList.remove('is-selected');
        });
        radio.closest('.promo-tier').classList.add('is-selected');
      });
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
